import React from 'react';

const SvgPause = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    {...props}
  >
    <path
      d="M5.14286 16.5H1.71429C0.767857 16.5 0 15.7321 0 14.7857V2.21429C0 1.26786 0.767857 0.5 1.71429 0.5H5.14286C6.08929 0.5 6.85714 1.26786 6.85714 2.21429V14.7857C6.85714 15.7321 6.08929 16.5 5.14286 16.5ZM16 14.7857V2.21429C16 1.26786 15.2321 0.5 14.2857 0.5H10.8571C9.91072 0.5 9.14286 1.26786 9.14286 2.21429V14.7857C9.14286 15.7321 9.91072 16.5 10.8571 16.5H14.2857C15.2321 16.5 16 15.7321 16 14.7857Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPause;
